import React, {useEffect, useState} from "react";
import swal from "sweetalert";
import Tab from '@mui/material/Tab';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import { connect } from "react-redux";
import TabList from '@mui/lab/TabList';
import { Button } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import AddIcon from '@mui/icons-material/Add';
import ToolTipModal from "../components/ToolTipModal";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import { openTooltipDialog,closeTooltipDialog, clearEditData } from "../state/tooltips/actions";
import { createEventTooltip,loadEventId,loadEventTooltips} from "../api/tooltipsapi";
import { getFilesLoading, getTooltipsData,getTooltipDialogStatus} from "../selector/selectors";
import Tooltips from "../components/Tooltips";

const EventsToolTip = ({
    isLoading,
    tooltipsList,
    createEventTooltip,
    startLoadingEventTooltips,
    tooltipDialogBoxStatus,
    lastEventId,
  }) => {
    const dispatch = useDispatch();
    const [value, setValue] = React.useState('1');
    const [searchValue, setSearchValue] = React.useState('');
    const [tooltipData, setTooltipData] = useState({
      event_id : '',
      event_name:'',
    });

    const [content, setContent] = useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChange = (event, newValue) =>{
      setValue(newValue);
    };
    const handleChangeTextValue = (event) => {
      setSearchValue(event.target.value);
      startLoadingEventTooltips(event.target.value);    
    };
    const handleClickCreateTooltip = (event) => {
      document.activeElement.blur();
      dispatch(loadEventId()); 
      dispatch(openTooltipDialog());
    };


    useEffect(() => {
      startLoadingEventTooltips('');
      dispatch(closeTooltipDialog());
    }, [startLoadingEventTooltips,dispatch]);
   
    const handleFormData = () => {
      const formData = new FormData(); 
      if(tooltipData.length === 0 || tooltipData.event_id === '' || tooltipData.event_name === '' || content.blocks.length <= 0 ){
        swal("Oops!", "Please fill required fields!", "error");
        return;
      }
      formData.append('description',JSON.stringify(content));
      //console.log('content',JSON.stringify(content));
      Object.keys(tooltipData).forEach(key => formData.append(key, tooltipData[key]));
      // console.log('formData',formData);
     // return false;
      createEventTooltip(formData);
      if(tooltipDialogBoxStatus === false) {
        dispatch(closeTooltipDialog());
      }
    }

    useEffect(() => {
      if(tooltipDialogBoxStatus === false) {
        setTooltipData({
          event_id : '',
          event_name:''
        });
        setContent('');
      }
    }, [tooltipDialogBoxStatus]);

    useEffect(() => {
      dispatch(clearEditData());
    }, [dispatch]);
    

    const handleChangePage = (event, pageVal) => {
      setPage(pageVal);
      startLoadingEventTooltips(searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
      startLoadingEventTooltips(searchValue,0,event.target.value);
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
          <Grid container >
            <TabContext value={value}>
              <Grid item xs={12} md={12} lg={12} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} aria-label="">
                    <Tab label="Event ToolTips" value="1" />
                </TabList>
                </Box>
                <TabPanel value="1" sx={{p:0,pt:2}}>
                  <Grid container sx={{paddingBottom:1, display: 'flex', justifyContent: 'space-between'}}>
                    <Grid >
                      <SearchBoxComponent 
                        handleChangeTextValue = {(e)=>handleChangeTextValue(e,'')}
                        label='Event ID / Description'
                      />
                    </Grid>
                    <Grid className="buttonSpacing">
                      <Button 
                        variant="contained"
                        size="medium"
                        color="primary"
                        onClick={(e)=>handleClickCreateTooltip(e)}
                      >
                        <AddIcon fontSize="medium"  sx={{paddingRight:1}} /> Add
                      </Button> 
                    </Grid>
                  </Grid>
                  <Tooltips page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} list={tooltipsList} />
                </TabPanel>
              </Grid>
            </TabContext>   
            <ToolTipModal 
              open={tooltipDialogBoxStatus}
              value={tooltipData}
              setTooltipData={setTooltipData}
              handleFormData={handleFormData}
              lastEventId={lastEventId}
              content={content}
              setContent={setContent}
            />   
          </Grid>
        </Box>
      );
}
const mapStateToProps = (state) => ({
  isLoading: getFilesLoading(state),  
  tooltipsList: getTooltipsData(state), 
  tooltipDialogBoxStatus: getTooltipDialogStatus(state),
  
});
  
const mapDispatchToProps = (dispatch) => ({
  createEventTooltip: (data)                => dispatch(createEventTooltip(data)),
  startLoadingEventTooltips: (searchText,page,rowsPerPage)   => dispatch(loadEventTooltips(searchText,page,rowsPerPage)),  
});
  
export default connect(mapStateToProps, mapDispatchToProps)(EventsToolTip);
